module.exports = __webpack_public_path__ + "static/media/Maybe IDK.72e60c39.mp3";